export var ContentIssueEnum;
(function (ContentIssueEnum) {
    ContentIssueEnum["ILLEGAL_VARIABLE_IN_CONTROL_VALUE"] = "ILLEGAL_VARIABLE_IN_CONTROL_VALUE";
    ContentIssueEnum["INVALID_FILTER_ARG_IN_VARIABLE"] = "INVALID_FILTER_ARG_IN_VARIABLE";
    ContentIssueEnum["INVALID_URL"] = "INVALID_URL";
    ContentIssueEnum["MISSING_VALUE"] = "MISSING_VALUE";
    ContentIssueEnum["TIER_LIMIT_EXCEEDED"] = "TIER_LIMIT_EXCEEDED";
    ContentIssueEnum["UNSUPPORTED_PROPERTY"] = "UNSUPPORTED_PROPERTY";
    ContentIssueEnum["CHAT_CARD_LIMIT_EXCEEDED"] = "CHAT_CARD_LIMIT_EXCEEDED";
})(ContentIssueEnum || (ContentIssueEnum = {}));
export var IntegrationIssueEnum;
(function (IntegrationIssueEnum) {
    IntegrationIssueEnum["MISSING_INTEGRATION"] = "MISSING_INTEGRATION";
    IntegrationIssueEnum["INBOX_NOT_CONNECTED"] = "INBOX_NOT_CONNECTED";
})(IntegrationIssueEnum || (IntegrationIssueEnum = {}));
/**
 * Blocking severity of a step issue. `ERROR` (the default when `severity` is omitted, for
 * backwards compatibility) means the value is invalid and must be fixed before the step can
 * deliver — it blocks save. `WARNING` is a non-blocking notice (e.g. a rich chat card a platform
 * will truncate/flatten but still deliver): the dashboard shows it without gating the workflow.
 */
export var StepIssueSeverityEnum;
(function (StepIssueSeverityEnum) {
    StepIssueSeverityEnum["ERROR"] = "error";
    StepIssueSeverityEnum["WARNING"] = "warning";
})(StepIssueSeverityEnum || (StepIssueSeverityEnum = {}));
export class RuntimeIssue {
    issueType;
    variableName;
    message;
    severity;
}
//# sourceMappingURL=issues.js.map